const distinct = (value, index, self) => {
  return self.indexOf(value) === index
}

export default distinct
